import { Component, OnInit } from "@angular/core";
import { authenticationService } from "src/app/Services/Authentication/authentication.service";
import { ViewController } from "@ionic/core";
import {
  PopoverController,
  ModalController,
  NavParams,
  ToastController,
  AlertController,
} from "@ionic/angular";
import { SharedService } from "src/app/Services/sheared/sharedService.service";
import { Router } from "@angular/router";
import { CotationService } from "src/app/Services/Cotation/cotation.service";
import { FactoryService } from "src/app/Services/historique/factory.service";
import { isNullOrUndefined } from "util";

@Component({
  selector: "app-tranferSimulComponent",
  templateUrl: "./transfert.component.html",
  styleUrls: ["./transfert.component.scss"],
})
export class TranferSimulComponent implements OnInit {
  livrer: boolean = false;
  lieu: string;
  heure: number;
  montantLivraison: number;
  Tels: any[] = [];
  Telstemp: any[] = [];
  valeurtel: string;

  private mySimulation;
  constructor(
    private viewCtrl: PopoverController,
    private _router: Router,
    private modalcontroller: ModalController,
    private nvparms: NavParams,
    private toastctl: ToastController,
    private facto: FactoryService,
    private _cotationService: CotationService,
    private alertController: AlertController
  ) {
    //this.montantLivraison =
    this.mySimulation = this.nvparms.get("value");
    console.log(this.mySimulation);
    
  }

  ngOnInit() {
    //this.isEnabled=false
  }

  async onCloseModal() {
    this.modalcontroller.dismiss();
    //this.facto.setData(50,"")
    // setTimeout(() => {
    //   this._router.navigate(['/home/cotation/formulaireauto'])
    // },300);
  }
  async onNext() {}
  onSelect(event) {
    if (event.target.value == "2") {
      this.livrer = true;
    } else {
      this.livrer = false;
    }
  }

  onValide() {
    if (this.livrer) {
      if (isNullOrUndefined(this.lieu) || this.lieu == "") {
        // this.presentErreur();
      } else {
        if (this.heure >= 9 && this.heure <= 17) {
          this._cotationService.livrerObject.next({
            livrer: this.livrer ? this.montantLivraison : 0,
            lieu: this.lieu,
            heure: this.heure,
          });
          this.modalcontroller.dismiss();
        } else {
          //this.presentErreur()
        }
      }
    } else {
      this._cotationService.livrerObject.next({
        livrer: 0,
        lieu: "",
        heure: 0,
      });
      this.modalcontroller.dismiss();
    }
  }

  addClient(event): void {
    this.Telstemp = [];
    this.Tels = [];
    try {
      if (event.trim() == "") {
        return;
      }
      this._cotationService.dataClient.next([]);
      this._cotationService.getCustom(event.trim());
      this._cotationService.dataClient.subscribe((data) => {
        if (data.length > 0) {
          if ((data[0].tel1 || "").trim()) {
            this.Telstemp.push(data[0]);
            this.Tels = this.UniqueDonne(this.Telstemp);
          }
        }
      });
  
      // Reset the input value
      if (event) {
        this.valeurtel = "";
      }
    } catch (error) {
      
    }
 
    // this.fruitCtrl.setValue(null);
  }
  onSearchKey(keycode) {
    if (keycode === 13) {
      this.addClient(this.valeurtel);
    }
  }
  partageSimul() {
    if (this.Tels !== undefined) {
      if (this.Tels.length > 0) {
        //let lsUid=this.Tels[0].uid
        //console.log(lsUid);

        // if (this.Tels[0]) {   }
        this._cotationService.setPartage(this.mySimulation, this.Tels[0]);
      }
    }
  }
  UniqueDonne(initDatas) {
    const result0 = [];
    const map = new Map();
    for (const item of initDatas) {
      if (!map.has(item.uid)) {
        map.set(item.uid, true); // set any value to Map
        result0.push(item);
      }
    }
    return result0;
  }
}
